/**
 * Generated by orval v7.16.0 🍺
 * Do not edit manually.
 * Analyzer API
 * Analyzer API gateway
 * OpenAPI spec version: 1.0.0
 */

export type FinancialAssetItemFinancialSubType =
  (typeof FinancialAssetItemFinancialSubType)[keyof typeof FinancialAssetItemFinancialSubType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const FinancialAssetItemFinancialSubType = {
  cash: "cash",
  bank_account: "bank_account",
  saving_account: "saving_account",
  building_saving: "building_saving",
  pension_saving: "pension_saving",
  investment: "investment",
  other: "other",
} as const;
